import { render, staticRenderFns } from "./FeatureTabModal.vue?vue&type=template&id=3b7c2096"
import script from "./FeatureTabModal.vue?vue&type=script&lang=js"
export * from "./FeatureTabModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports